export type Family = "tabular" | "anomaly" | "forecast";

export const FAMILY_OF_TASK_TYPE: Record<string, Family> = {
  tabular_classification: "tabular",
  tabular_regression: "tabular",
  tabular_quantile: "tabular",
  anomaly_detection: "anomaly",
  timeseries_forecast: "forecast",
};

export function familyOf(taskType: string | null | undefined): Family | null {
  if (!taskType) return null;
  return FAMILY_OF_TASK_TYPE[taskType] ?? null;
}

export function isKnownTaskType(taskType: string | null | undefined): boolean {
  return familyOf(taskType) !== null;
}
